import { toast as hotToast } from 'react-hot-toast';

// Configure default options
const toast = Object.assign(
  (message, options?: object) =>
    hotToast(message, { duration: 5000, ...(options || {}) }),
  {
    ...hotToast,
    success: (message, options?: object) =>
      hotToast.success(message, { duration: 5000, ...(options || {}) }),
    error: (message, options?: object) =>
      hotToast.error(message, { duration: 8000, ...(options || {}) }),
    loading: hotToast.loading,
  }
);

export default toast;
